import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ICareerTag {
	label: string;
	slug: string;
	taxonomy: string;
	href: string;
}

export interface ICareerCardProps extends IBaseElementProps {
	ID?: number;
	/**
	 * Career Link
	 */
	careerLink?: ILink;
	/**
	 * Career Title
	 */
	careerTitle?: string;
	/**
	 * Career Location
	 */
	careerLocation?: any[];
	/**
	 * Career Type
	 */
	careerType?: string;
	/**
	 * Career Location
	 */
	careerOfficeType?: string;
	/**
	 * Career Opportunity Tags
	 */
	careerTags?: ICareerTag[];
	/**
	 * Career Posting Date
	 */
	careerPostingDate?: string;
	/**
	 * Used for client-side filtering
	 * @noUI
	 */
	allTerms?: {
		[key:string]: string[];
	};
	/**
	 * @noUI
	 */
	onClickTerm?: (taxonomy:string,value:string) => void;
}

/**
 * Calian Career Card Component
 */
const CareerCard: React.FC<ICareerCardProps> = ({
	className,
	classNames = [],
	careerLink,
	careerTitle,
	careerLocation,
	careerType,
	careerOfficeType,
	careerTags,
	careerPostingDate,
	onClickTerm,
}) => {
	const handleOnClickTerm = (e:React.MouseEvent<HTMLElement>,taxonomy:string,value:string) => {
		if ( onClickTerm ) {
			e.preventDefault();
			onClickTerm(taxonomy,value);
		}
	}
	return <div className={className || cn('calian-career-card', ...classNames)}>
		{careerLink && (
			<a
				className="calian-career-card__main-link"
				href={careerLink.href}
				target={careerLink.target}
				title={careerLink.label}
			>
				<div className="calian-career-card__container container-fluid">
					<div className="row">
						<div className="calian-career-card__top col-12">
							{careerTitle && (
								<div className="calian-career-card__top--left">
									<h5 className="calian-career-card__title">
										{careerTitle}
									</h5>
								</div>
							)}
							<div className="calian-career-card__top--right">
								{(careerLocation || []).map(
									(location, index) => (
										<p key={index} className="calian-career-card__location" onClick={e => handleOnClickTerm(e,'location',location.slug)}>
											{location.name}{location.province ? ` , ${location.province}` : ''}
										</p>
									)
								)}
								{careerType && (
									<p className="calian-career-card__type">
										{careerType}
									</p>
								)}
								{careerOfficeType && (
									<p className="calian-career-card__office-type">
										{careerOfficeType}
									</p>
								)}
							</div>
						</div>
						<div className="calian-career-card__bottom col-12">
							<div className="calian-career-card__bottom--left">
								{careerTags && careerTags.length > 0 && (
									<ul className="calian-career-card__tags list-inline">
										{careerTags.map(({label,taxonomy,slug}, index) => (
											<li
												key={index}
												className="calian-career-card__tag list-inline-item"
												onClick={e => handleOnClickTerm(e,taxonomy,slug)}
											>
												<span className="calian-career-card__tag--btn btn btn-sm btn-white">
													{label}
												</span>
											</li>
										))}
									</ul>
								)}
							</div>
							<div className="calian-career-card__bottom--right">
								{careerPostingDate && (
									<p className="calian-career-card__posting-date">
										{careerPostingDate}
									</p>
								)}
							</div>
						</div>
					</div>
				</div>
			</a>
		)}
	</div>
};

export default CareerCard;
